import $ from 'jquery';
import mergeOptions from "styleguide/lib/merge-options";

const DEFAULTS = {};
const CONTAINER_CLASS = '.js-revieve-container';
const BUTTON_CLASS = '.js-revieve-try-on';

export const revieveTryOn = (options) => {
    const $el = $(BUTTON_CLASS);
    const opts = mergeOptions(DEFAULTS, options, $el);

    if ($el.length) {
        window.activateRevieveFullLook(() => {
            try {
                if (opts.isPlp) {
                    if (opts.checkAvailability) {
                        let codes = [];
                        $('li.js-plp-container').each((index, element) => {
                            const $element = $(element);
                            $element.attr('data-loader', 'tryOnLoader');
                        });
                        $('li.js-plp-container').Lazy({
                            tryOnLoader: function (element, response) {
                                const $element = $(element);
                                const code = $element.attr('id');
                                Revieve.API.liveAR.isTryOnAvailable({product_id: code}, (available) => {
                                    if (available) {
                                        $element.find(CONTAINER_CLASS).removeClass('u-hide');
                                        codes.push(code);
                                    }
                                });
                            }
                        });
                        Revieve.API.liveAR.loadTryOnProducts(codes);
                    }
                } else {
                    Revieve.API.liveAR.isTryOnAvailable({product_id: opts.code}, (available) => {
                        if (available) {
                            $(CONTAINER_CLASS).removeAttr('style');
                        }
                    });
                }
            } catch (ignored) {
            }

            setEventListeners($el)
        });
    }
}

export const revieveAddToBag = () => {
    $(window).on('revieveAddToBag', (e, data) => {
        data.products.forEach((product) => {
            addProductWithData({
                productCode: product.id,
                size: 'all',
                sectionURL: data.sectionUrl,
                csrfHash: data.csrfHash,
                useReferrer: true,
                isPopup: false,
                hotlistQuickView: false,
                count: 1,
                closeWindowAfterAddingToCart: true,
                src: 'revieve_atc',
            });

            if (typeof insertFacebookAddToCart === 'function') {
                insertFacebookAddToCart(null, product.id, product.price, 'all');
            }

            if (typeof addToCartReddit === 'function') {
                const cartItems = [{
                    productCode: product.id,
                    productName: product.name,
                    productCategory: 'Beauty'
                }];
                addToCartReddit(cartItems, product.price, product.id, product.name, product.category);
            }
            if (typeof spanglePixelAddToCart === 'function') {
                spanglePixelAddToCart(product.id, product.price, 1);
            }
        });
    });
}

function setEventListeners($el) {
    $el.on('click', (e) => {
        e.preventDefault();
        const productCode = $(e.target).data('code');

        if (window.rcProps.activeRevievePlugin === 'FULL_LOOK') {
            openPlugin(productCode);
        } else {
            window.activateRevieveFullLook(() => {
                openPlugin(productCode);
            })
        }
    });
}

function openPlugin(code) {
    Revieve.API.liveAR.addTryOnProduct(code);
    Revieve.API.show();
    // VTO stands for Virtual Try On
    logEngagement(window.location.href, 'VTO', 'Open');
}



// WEBPACK FOOTER //
// ./src/scripts/modules/revieve-try-on.js